import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BeaconError, BeaconErrorType } from '..';
/**
 * @category Error
 */

export var TransactionInvalidBeaconError = /*#__PURE__*/function (_BeaconError) {
  _inherits(TransactionInvalidBeaconError, _BeaconError);

  var _super = _createSuper(TransactionInvalidBeaconError);

  function TransactionInvalidBeaconError(data) {
    var _this;

    _classCallCheck(this, TransactionInvalidBeaconError);

    _this = _super.call(this, BeaconErrorType.TRANSACTION_INVALID_ERROR, "The transaction is invalid and the node did not accept it.");
    _this.data = data;
    _this.name = 'TransactionInvalidBeaconError';
    _this.title = 'Transaction Invalid';
    _this.data = data;
    return _this;
  }

  _createClass(TransactionInvalidBeaconError, [{
    key: "fullDescription",
    get: function get() {
      return "".concat(this.description, "<br /><pre style=\"text-align: left\">").concat(JSON.stringify(this.data, undefined, 2), "</pre>");
    }
  }]);

  return TransactionInvalidBeaconError;
}(BeaconError);